export class ApiRequestError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly details?: Record<string, unknown>
  ) {
    super(message);
    this.name = "ApiRequestError";
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, { ...init, credentials: "same-origin" });

  if (res.status === 204) return undefined as T;

  const body: unknown = await res.json().catch(() => null);

  if (!res.ok) {
    const b = (body ?? {}) as { code?: string; message?: string; details?: Record<string, unknown> };
    throw new ApiRequestError(res.status, b.code ?? "unknown_error", b.message ?? `Fehler ${res.status}`, b.details);
  }

  return body as T;
}

export const api = {
  get: <T>(path: string) => request<T>(path, { headers: { "Content-Type": "application/json" } }),
  post: <T>(path: string, body?: unknown) =>
    request<T>(
      path,
      body === undefined
        ? { method: "POST" }
        : { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }
    ),
  // Multipart uploads: no Content-Type header — the browser sets the correct
  // boundary itself, which is required for the server to parse the form.
  postForm: <T>(path: string, form: FormData) => request<T>(path, { method: "POST", body: form }),
  put: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body ?? {}) }),
  // Raw binary PUT (podcast audio multipart parts) — the server reads the
  // request body via c.req.arrayBuffer(), so no JSON encoding/Content-Type here.
  putRaw: <T>(path: string, body: Blob) => request<T>(path, { method: "PUT", body }),
  delete: <T>(path: string) => request<T>(path, { method: "DELETE" })
};
